import { render } from "./GroupBookingView.vue?vue&type=template&id=8013bd58&scoped=true&ts=true"
import script from "./GroupBookingView.vue?vue&type=script&lang=ts"
export * from "./GroupBookingView.vue?vue&type=script&lang=ts"

import "./GroupBookingView.vue?vue&type=style&index=0&id=8013bd58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8013bd58"]])

export default __exports__